export const semanticColors = {
  backgroundDeep: '#081312',
  backgroundPanel: '#0e1d1c',
  backgroundElevated: '#123a39',
  jade: '#1aa68c',
  turquoise: '#35c6b5',
  sunGold: '#d9a83e',
  solarGold: '#ffd36a',
  sandstone: '#d8c7a4',
  parchment: '#f1e7cf',
  maize: '#d6a53c',
  coral: '#d9654d',
  lake: '#2c8ca3',
  cloud: '#dde9e5',
  ink: '#18201e',
} as const;

export const spacingScale = [4, 8, 12, 16, 24, 32, 48, 64] as const;

export const motionDurations = {
  instant: 1,
  press: 100,
  panel: 200,
  camera: 280,
} as const;

export type SemanticColor = keyof typeof semanticColors;
